//Reset data
export const RESET = "TICKET_UPDATE_RESET"

export const SET_IS_UPDATED = "TICKET_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "TICKET_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "TICKET_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "TICKET_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "TICKET_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "TICKET_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "TICKET_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "TICKET_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "TICKET_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "TICKET_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "TICKET_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "TICKET_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "TICKET_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "TICKET_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "TICKET_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "TICKET_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "TICKET_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "TICKET_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "TICKET_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "TICKET_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "TICKET_UPDATE_SET_MODAL_TYPE"